import axios from 'axios';
import Cookies from 'js-cookie';

import { API_CONFIG } from '../api/config/env';

const addTokenCookie = (token: string) => {
  if (!window.location.host.startsWith('localhost')) {
    Cookies.set(`${API_CONFIG.COOKIE_PREFIX}_token`, token, {
      domain: `.mindd.ybrain.com`,
      expires: 7,
    });
  } else {
    Cookies.set(`${API_CONFIG.COOKIE_PREFIX}_token`, token, { expires: 7 });
  }
};

const removeTokenCookie = () => {
  if (!window.location.host.startsWith('localhost')) {
    Cookies.remove(`${API_CONFIG.COOKIE_PREFIX}_token`, {
      domain: `.mindd.ybrain.com`,
    });
  } else {
    Cookies.remove(`${API_CONFIG.COOKIE_PREFIX}_token`);
  }
};

const WebTokenManager = {
  hasToken: () => {
    try {
      return window.localStorage.getItem('token') !== null;
    } catch (e) {
      console.warn('[WebTokenManager] localStorage.getItem 실패', e);
      return false;
    }
  },
  getToken: () => {
    try {
      return window.localStorage.getItem('token');
    } catch (e) {
      console.warn('[WebTokenManager] localStorage.getItem 실패', e);
      return null;
    }
  },
  setToken: (token: string) => {
    try {
      window.localStorage.setItem('token', token);
    } catch (e) {
      console.warn('[WebTokenManager] localStorage.setItem 실패 — 쿠키·axios 헤더로 인증 유지', e);
    }
    addTokenCookie(token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  },
  clear: () => {
    try {
      window.localStorage.removeItem('token');
    } catch (e) {
      console.warn('[WebTokenManager] localStorage.removeItem 실패', e);
    }
    removeTokenCookie();
    axios.defaults.headers.common['Authorization'] = ``;
  },
};

const readTokenFromQuery = (): string | null => {
  try {
    return new URLSearchParams(window.location.search).get('token');
  } catch {
    return null;
  }
};

const stripTokenFromUrl = () => {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    window.history.replaceState({}, '', url.toString());
  } catch {
    // noop
  }
};

// mobile.routes(/m/..., /phr)는 자체 인증 흐름을 사용하므로 자동 로그인에서 제외
const isMobileRoute = () => {
  const path = window.location.pathname;
  return path === '/m' || path.startsWith('/m/') || path === '/phr' || path.startsWith('/phr/');
};

const queryToken = readTokenFromQuery();
if (queryToken && !isMobileRoute()) {
  WebTokenManager.setToken(queryToken);
  stripTokenFromUrl();
} else {
  let token: string | null = null;
  try {
    token = window.localStorage.getItem('token');
  } catch (e) {
    console.warn('[WebTokenManager] localStorage.getItem 실패', e);
  }
  if (token) {
    addTokenCookie(token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    removeTokenCookie();
    axios.defaults.headers.common['Authorization'] = '';
  }
}

export default WebTokenManager;
